import { createRouter, createWebHistory } from "vue-router";
// createWebHistory;  历史模式
// createWebHashHistory;  哈希模式
let routes = [
    {
        path: "/",
        component: () => import("@/views/index.vue"),
        redirect: "/home",
        children: [
            {
                path: "home",
                name: "home",
                component: () => import("@/views/Home/index.vue"),
            },
            {
                path: "homeDetail",
                name: "homeDetail",
                component: () => import("@/views/Home/components/detail.vue"),
            },
            {
                path: "popularCartoon",
                name: "popularCartoon",
                component: () => import("@/views/popularCartoon/index.vue"),
            },
            {
                path: "userSuggestHandle",
                name: "userSuggestHandle",
                component: () => import("@/views/userSuggestHandle/index.vue"),
            },
            {
                path: "contentSystem",
                name: "contentSystem",
                component: () => import("@/views/contentSystem/index.vue"),
            },
            {
                path: "userProtocol",
                name: "userProtocol",
                component: () => import("@/views/userProtocol/index.vue"),
            },
            {
                path: "complaint",
                name: "complaint",
                component: () => import("@/views/complaint/index.vue"),
            },
            {
                path: "about",
                name: "about",
                component: () => import("@/views/about/index.vue"),
            },
        ],
    },
    {
        path: "/parentsSupervise",
        component: () => import("@/views/parentsSupervise/index.vue"),
        redirect: "/parentsSupervise/parentsSuperviseHome",
        children: [
            {
                path: "parentsSuperviseHome",
                name: "parentsSuperviseHome",
                component: () =>
                    import("@/views/parentsSupervise/home/index.vue"),
            },
            {
                path: "serviceFlow",
                name: "serviceFlow",
                component: () =>
                    import("@/views/parentsSupervise/serviceFlow/index.vue"),
            },
            {
                path: "commonProblem",
                name: "commonProblem",
                component: () =>
                    import("@/views/parentsSupervise/commonProblem/index.vue"),
            },
        ],
    },
];

// 3. 创建路由实例并传递 `routes` 配置。
const router = createRouter({
    // 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
    history: createWebHistory(),
    // 将通用路由和模块路由合并
    routes: routes,
});

export default router;
